import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = []

    connect() {
        this.lightbox = document.getElementById('imageLightbox')
        this.lightboxImg = document.getElementById('lightboxImage')
        this.closeLightbox = document.getElementById('closeLightbox')
        this.prevBtn = document.getElementById('prevImage')
        this.nextBtn = document.getElementById('nextImage')
        this.currentIndexSpan = document.getElementById('currentImageIndex')
        this.totalImagesSpan = document.getElementById('totalImages')
        
        this.currentImageIndex = 0
        this.imageUrls = []
        
        this.initializeEventListeners()
    }

    initializeEventListeners() {
        if (!this.lightbox) return
        
        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('main-image')) {
                e.preventDefault()
                const imageUrl = e.target.dataset.main || e.target.src
                this.openLightbox(imageUrl)
            }
        })
        
        this.closeLightbox?.addEventListener('click', () => this.closeLightboxFn())
        
        this.prevBtn?.addEventListener('click', (e) => {
            e.stopPropagation()
            this.showPrev()
        })
        
        this.nextBtn?.addEventListener('click', (e) => {
            e.stopPropagation()
            this.showNext()
        })
        
        this.lightbox.addEventListener('click', (e) => {
            if (e.target === this.lightbox) {
                this.closeLightboxFn()
            }
        })
        
        document.addEventListener('keydown', (e) => {
            if (!this.lightbox.classList.contains('open')) return
            
            switch(e.key) {
                case 'Escape':
                    this.closeLightboxFn()
                    break
                case 'ArrowLeft':
                    this.showPrev()
                    break
                case 'ArrowRight':
                    this.showNext()
                    break
            }
        })
        
        this.initializeTouchEvents()
    }

    initializeTouchEvents() {
        let touchStartX = 0
        let touchEndX = 0
        
        this.lightbox.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX
        }, { passive: true })
        
        this.lightbox.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX
            this.handleSwipe(touchStartX, touchEndX)
        }, { passive: true })
    }

    handleSwipe(startX, endX) {
        const swipeThreshold = 50
        const diff = startX - endX
        
        if (Math.abs(diff) > swipeThreshold) {
            if (diff > 0) {
                this.showNext()
            } else {
                this.showPrev()
            }
        }
    }

    collectImages() {
        this.imageUrls = []
        const allImages = document.querySelectorAll('.main-image, .thumbnail')
        allImages.forEach(img => {
            const url = img.dataset.main || img.src
            if (url && !this.imageUrls.includes(url)) {
                this.imageUrls.push(url)
            }
        })
        
        this.totalImagesSpan.textContent = this.imageUrls.length
        this.lightbox.setAttribute('data-single-image', this.imageUrls.length === 1)
    }

    openLightbox(imageUrl) {
        this.collectImages()
        this.currentImageIndex = this.imageUrls.indexOf(imageUrl)
        if (this.currentImageIndex === -1) this.currentImageIndex = 0
        
        this.showImage(this.currentImageIndex)
        this.lightbox.classList.add('open')
        document.body.style.overflow = 'hidden'
    }

    showImage(index) {
        if (index < 0) index = this.imageUrls.length - 1
        if (index >= this.imageUrls.length) index = 0
        
        this.currentImageIndex = index
        this.lightboxImg.src = this.imageUrls[this.currentImageIndex]
        this.currentIndexSpan.textContent = this.currentImageIndex + 1
        
        this.lightboxImg.style.opacity = '0'
        setTimeout(() => {
            this.lightboxImg.style.opacity = '1'
        }, 50)
    }

    closeLightboxFn() {
        this.lightbox.classList.remove('open')
        document.body.style.overflow = 'auto'
    }

    showNext() {
        this.showImage(this.currentImageIndex + 1)
    }

    showPrev() {
        this.showImage(this.currentImageIndex - 1)
    }

    disconnect() {
        document.body.style.overflow = 'auto'
    }
}

